<template>
  <a-card
      :bordered="true"
      class="management-flags-block pdf-avoid-break"
  >
    <div v-if="title" class="management-flags-block__header">
      <h3 class="management-flags-block__title">
        {{ title }}
      </h3>

      <QuestionCircleOutlined class="management-flags-block__help-icon" />
    </div>

    <FlagsDetailedCard
        :groups="groups"
        :segments="segments"
        :smallGap="false"
    />
  </a-card>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

import FlagsDetailedCard from '@/components/Analytics/FlagsDetailedCard.vue'

export default {
  name: 'ManagementFlagsBlock',

  components: {
    QuestionCircleOutlined,
    FlagsDetailedCard,
  },

  props: {
    title: {
      type: String,
      default: 'Зеленые и красные флаги',
    },

    groups: {
      type: Array,
      default: () => [],
    },

    segments: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.management-flags-block {
  width: 100%;
  border-radius: 8px;
}

.management-flags-block :deep(.ant-card-body) {
  padding: 18px 16px 14px;
}

.management-flags-block__header {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.management-flags-block__title {
  min-width: 0;
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.management-flags-block__help-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
}

.management-flags-block :deep(.flags-detailed-card__groups) {
  gap: 20px;
}

.management-flags-block :deep(.flags-detailed-card__group-header) {
  margin-bottom: 12px;
}

.management-flags-block :deep(.flags-detailed-card__bar) {
  margin-top: 14px;
}

@media (max-width: $mobile-breakpoint) {
  .management-flags-block :deep(.flags-detailed-card__row) {
    grid-template-columns: minmax(0, 1fr) minmax(24px, 34px) minmax(44px, 54px);
    gap: 8px;
    padding-left: 18px;
  }
}
</style>